// libs
import React, { memo } from 'react';

// global components
import RouteChunkRenderer from 'shared/components/RouteChunkRenderer';

// component
import SizeGuide from 'shared/layouts/SizeGuide';

function SizeGuideSkuVersion() {
  return (
    <RouteChunkRenderer
      mobileComponent={<SizeGuide srcApp />}
      desktopComponent={<SizeGuide srcApp={false} isDesktop={true} />}
    />
  );
}

export default memo(SizeGuideSkuVersion);
